import React, { useEffect, useState, useCallback } from 'react';
import { ContentSteps } from '../styles';
import publicIp from 'public-ip';

// Context
import { useSignature } from '../../../../hooks/SignatureContext';
import { useRetentionSignature } from '../../../../hooks/RetentionSignatureContext';

// Service
import SignatureService from '../../../../services/SignatureService';
// Component
import { Loader } from '../../../../components/UISignatue/Loader';

import { ErrorPermissions } from '../../ScreensError/index';
// SVG
import { IconErrorPermissionGeolocation } from '../../ScreensError/svg';
import Signature from '../../../../interfaces/Signature';
import logger from '../../../../utils/logger.utils';

interface ITerms {
  formValues: Signature;
  isRetention?: boolean;
}

export const Terms = ({ formValues, isRetention }: ITerms) => {
  const signatureContext = useSignature();
  const retentionContext = useRetentionSignature();

  const context = isRetention ? retentionContext : signatureContext;
  const { setFormOpened, setNextStepDisabled, setErrorGelocation, errorGelocation, termId } = context;
  const [loading, setLoading] = useState(false);

  const [url, setUrl] = useState(String);

  const handleFormInput = useCallback(() => {
    setFormOpened(formValues);
  }, [formValues]);

  useEffect(() => {
    const withRetry = async (fn: () => Promise<any>, retries = 2, delay = 1500): Promise<any> => {
      try {
        return await fn();
      } catch (err) {
        if (retries > 0) {
          await new Promise((r) => setTimeout(r, delay));
          return withRetry(fn, retries - 1, delay);
        }
        throw err;
      }
    };

    const handleFecthTerms = async () => {
      try {
        setLoading(true);
        setNextStepDisabled(true);
        let fetchTerms;
        if (termId) {
          fetchTerms = await withRetry(() => SignatureService.fetchTermsWithId(termId));
        } else {
          fetchTerms = await withRetry(() => SignatureService.fetchTerms());
        }
        const { data } = fetchTerms;
        setUrl(data.html);
        setLoading(false);
        setNextStepDisabled(false);
      } catch (error) {
        logger.error('Error fetching terms');
      }
    };
    handleFecthTerms();
  }, []);

  useEffect(() => {
    const getClientIp = async () => {
      try {
        const ipV4 = await publicIp.v4();
        formValues.customerIP = ipV4;
      } catch (error) {
        logger.error('Error getting client IP');
      }
    };
    getClientIp();
    formValues.token = localStorage.getItem('token') || '';
  }, [formValues]);

  useEffect(() => {
    const getPosition = async () => {
      const geolocation = navigator.geolocation;
      try {
        await geolocation.getCurrentPosition(
          (position) => {
            formValues.customerLatitude = String(position.coords.latitude);
            formValues.customerLongitude = String(position.coords.longitude);
          },
          () => {
            setNextStepDisabled(true);
            setErrorGelocation(true);
            logger.warn('Permission denied');
          },
        );
      } catch (error) {
        logger.error('Error: Permission denied');
      }
    };
    getPosition();
  }, [formValues]);

  useEffect(() => {
    handleFormInput();
  }, []);

  return (
    <ContentSteps className={`${errorGelocation ? 'errorPermissionGeolocation' : 'terms'}`}>
      {errorGelocation ? (
        <ErrorPermissions
          titlePage={'Localização'}
          cardTitle={'Sem acesso à localização'}
          cardFooterlink={'https://support.google.com/chrome/answer/2693767?hl=pt-BR&co=GENIE.Platform%3DAndroid&oco=0'}
          cardFooterText={'Como permitir acesso à localização!'}
          icon={IconErrorPermissionGeolocation}
        >
          Por questões de segurança, precisamos ter acesso a localização do seu celular para confirmar a assinatura.
          <br />
          <br />
          Permita acesso à localização do dispositivo para continuar
        </ErrorPermissions>
      ) : (
        <>
          {/* <TitleSteps>Termos de uso</TitleSteps> */}
          {loading ? (
            <>
              <Loader black title="Carregando termos de uso" />
            </>
          ) : (
            <iframe id="myIframe" src={url} title="Termos de uso Assinatura" />
          )}
        </>
      )}
    </ContentSteps>
  );
};
